import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Landscape from "@material-ui/icons/Landscape";
import Search from "@material-ui/icons/Search"

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import pillsStyle from "assets/jss/prehnit/views/landingPageSections/pillsStyle.jsx";

import { withNamespaces } from "react-i18next";

import { API } from "services/api";

class SectionPills extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      clcBases: undefined,
      clcChanges: undefined,
      localComponent: undefined,
      dataLoaded: false
    };
  }

  filterData(data, col, id) {
    return data.filter(row => {
      return row[col] === id;
    });
  }

  componentDidMount() {
    API.getContentLists()
      .then(data => {
        let clcBases = this.filterData(data, 'group_code', 'clc-base');
        let clcChanges = this.filterData(data, 'group_code', 'clc-change');
        let localComponent = this.filterData(data, 'group_code', 'local-component');

        this.setState({
          clcBases: clcBases,
          clcChanges: clcChanges,
          localComponent: localComponent,
          dataLoaded: true
        })
      })

  }

  render() {
    const { t, classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <div id="navigation-pills">
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                {this.state.dataLoaded ? <NavPills
                  color="primary"
                  horizontal={{
                    tabsGrid: { xs: 12, sm: 3, md: 4 },
                    contentGrid: { xs: 12, sm: 9, md: 8 }
                  }}
                  tabs={[
                    {
                      tabButton: t("comp-local"),
                      tabIcon: Dashboard,
                      tabContent: (
                        <span>
                          <h3>{t("comp-local")}</h3>
                          <p>{t("local-para1")}</p>
                          <p>{t("local-para2")}</p>
                          <ol>
                            {this.state.localComponent.map((el, key) => {
                              return (
                                <li key={key}><p>{t(el.title_trans_token)} (<span className={classes.itemCount}>{t(el.dsc_trans_token)}</span>)</p></li>
                              );
                            })}
                          </ol>
                          <p>{t("local-para3")}</p>
                          <p><a href={t("local-url")} target="_blank" rel="noopener noreferrer">{t("local-url")}</a></p>
                        </span>
                      )
                    },
                    {
                      tabButton: t("comp-paneu"),
                      tabIcon: Landscape,
                      tabContent: (
                        <span>
                          <h3>{t("comp-paneu")}</h3>
                          <p>{t("paneu-para1")}</p>
                          <p>{t("paneu-para2")}</p>
                          <p>{t("paneu-para3")}</p>
                          <p><a href={t("paneu-url")} target="_blank" rel="noopener noreferrer">{t("paneu-url")}</a></p>
                          <p>{t("paneu-para4")}</p>
                          <p>{t("paneu-list1")}</p>
                          <ol>
                            {this.state.clcChanges.map((el, key) => {
                              return (
                                <li key={key}><p>{t(el.title_trans_token)}</p></li>
                              );
                            })}
                          </ol>
                          <p>{t("paneu-list2")}</p>
                          <ol>
                            {this.state.clcBases.map((el, key) => {
                              return (
                                <li key={key}><p>{t(el.title_trans_token)}</p></li>
                              );
                            })}
                          </ol>

                        </span>
                      )
                    },
                    {
                      tabButton: t("comp-hrl"),
                      tabIcon: Search,
                      tabContent: (
                        <span>
                          <h3>{t("comp-hrl")}</h3>
                          <p>{t("hrl-para1")}</p>
                          <p>{t("hrl-para2")}</p>
                          <p>{t("hrl-para3")}</p>
                          <p><a href={t("hrl-url")} target="_blank" rel="noopener noreferrer">{t("hrl-url")}</a></p>
                        </span>
                      )
                    }
                  ]}
                /> : null}
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces(['pagecontent'])(withStyles(pillsStyle)(SectionPills));
